var map = {
	"./Orange.png": "./src/EGRContent/Story/BhanaMaKoHun/images/Orange.png",
	"./apple.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/apple.gif",
	"./apple.png": "./src/EGRContent/Story/BhanaMaKoHun/images/apple.png",
	"./apple_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/apple_un.png",
	"./background1.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background1.png",
	"./background2.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background2.png",
	"./background3.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background3.png",
	"./background4.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background4.png",
	"./background5.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background5.png",
	"./background6.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background6.png",
	"./background7.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background7.png",
	"./background8.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background8.png",
	"./background9.png": "./src/EGRContent/Story/BhanaMaKoHun/images/background9.png",
	"./ball.png": "./src/EGRContent/Story/BhanaMaKoHun/images/ball.png",
	"./ballon.png": "./src/EGRContent/Story/BhanaMaKoHun/images/ballon.png",
	"./banana.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/banana.gif",
	"./banana.png": "./src/EGRContent/Story/BhanaMaKoHun/images/banana.png",
	"./banana_temp.png": "./src/EGRContent/Story/BhanaMaKoHun/images/banana_temp.png",
	"./bisc.png": "./src/EGRContent/Story/BhanaMaKoHun/images/bisc.png",
	"./black_grapes.png": "./src/EGRContent/Story/BhanaMaKoHun/images/black_grapes.png",
	"./boat.png": "./src/EGRContent/Story/BhanaMaKoHun/images/boat.png",
	"./caps.png": "./src/EGRContent/Story/BhanaMaKoHun/images/caps.png",
	"./chocolate.png": "./src/EGRContent/Story/BhanaMaKoHun/images/chocolate.png",
	"./coco_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/coco_un.png",
	"./coconut.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/coconut.gif",
	"./color.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/color.gif",
	"./cover_page_ma_ko_hun.png": "./src/EGRContent/Story/BhanaMaKoHun/images/cover_page_ma_ko_hun.png",
	"./credit_page.png": "./src/EGRContent/Story/BhanaMaKoHun/images/credit_page.png",
	"./crown.png": "./src/EGRContent/Story/BhanaMaKoHun/images/crown.png",
	"./egg.png": "./src/EGRContent/Story/BhanaMaKoHun/images/egg.png",
	"./grapes.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/grapes.gif",
	"./grapes_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/grapes_un.png",
	"./green_grapes.png": "./src/EGRContent/Story/BhanaMaKoHun/images/green_grapes.png",
	"./group_marble.png": "./src/EGRContent/Story/BhanaMaKoHun/images/group_marble.png",
	"./half_coco.png": "./src/EGRContent/Story/BhanaMaKoHun/images/half_coco.png",
	"./hand.png": "./src/EGRContent/Story/BhanaMaKoHun/images/hand.png",
	"./head.png": "./src/EGRContent/Story/BhanaMaKoHun/images/head.png",
	"./last_cover_page_ma_ko_hun.png": "./src/EGRContent/Story/BhanaMaKoHun/images/last_cover_page_ma_ko_hun.png",
	"./lasun.png": "./src/EGRContent/Story/BhanaMaKoHun/images/lasun.png",
	"./leaf.png": "./src/EGRContent/Story/BhanaMaKoHun/images/leaf.png",
	"./lemon.png": "./src/EGRContent/Story/BhanaMaKoHun/images/lemon.png",
	"./mango.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/mango.gif",
	"./mango_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/mango_un.png",
	"./melon_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/melon_un.png",
	"./orange.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/orange.gif",
	"./orange_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/orange_un.png",
	"./pomegranate.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/pomegranate.gif",
	"./pomello.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/pomello.gif",
	"./pomello_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/pomello_un.png",
	"./pomu_un.png": "./src/EGRContent/Story/BhanaMaKoHun/images/pomu_un.png",
	"./rose.png": "./src/EGRContent/Story/BhanaMaKoHun/images/rose.png",
	"./section.png": "./src/EGRContent/Story/BhanaMaKoHun/images/section.png",
	"./single_marble.png": "./src/EGRContent/Story/BhanaMaKoHun/images/single_marble.png",
	"./smile.png": "./src/EGRContent/Story/BhanaMaKoHun/images/smile.png",
	"./sun.png": "./src/EGRContent/Story/BhanaMaKoHun/images/sun.png",
	"./teeth.png": "./src/EGRContent/Story/BhanaMaKoHun/images/teeth.png",
	"./thumbnail_LaBhanaMaKoHun.png": "./src/EGRContent/Story/BhanaMaKoHun/images/thumbnail_LaBhanaMaKoHun.png",
	"./tika.png": "./src/EGRContent/Story/BhanaMaKoHun/images/tika.png",
	"./watermelon.gif": "./src/EGRContent/Story/BhanaMaKoHun/images/watermelon.gif",
	"./yellow.png": "./src/EGRContent/Story/BhanaMaKoHun/images/yellow.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/BhanaMaKoHun/images sync recursive ^\\.\\/.*$";